import {takeEvery, call, put} from 'redux-saga/effects';
import {CommentActions} from '../actions'
import axios from 'axios';
import {toastr} from 'react-redux-toastr';
import {push} from 'react-router-redux';
import {RouteUrls} from '../configs/routeUrls';

const commentUrl  = '/api/comments';

export function* watchLoadCommentsByModerator() {
    yield takeEvery(CommentActions.LoadCommentsByModeratorAction.Request, loadCommentsByModerator);
}
function* loadCommentsByModerator(action) {
    try {
        const comments = yield call(loadCommentsByModeratorRequest, action.payload);
        yield put({
            type: CommentActions.LoadCommentsByModeratorAction.Success,
            payload: comments
        });
    } catch (e) {
        yield put({type: CommentActions.LoadCommentsByModeratorAction.Failure});
        toastr.error('Błąd pobierania komentarzy',
            'Wystąpił niespodziewany błąd podczas pobierania listy komentarzy do moderacji');

    }
}
function loadCommentsByModeratorRequest(moderatorId) {
    return axios.get(`${commentUrl}?moderatorId=${moderatorId}`)
        .then(response => response.data)
        .catch(err => {
            throw err;
        });
};

export function* watchUpdateComment() {
    yield takeEvery(CommentActions.UpdateCommentAction.Request, updateComment);
}
function* updateComment(action) {
    try {
        const comment = yield call(updateCommentRequest, action.payload);
        yield put({
            type: CommentActions.UpdateCommentAction.Success,
            payload: comment
        });
        toastr.success('Aktualizacja komentarza',
            'Poprawnie zaktualizowano komentarz');
        yield put(push(RouteUrls.Comment.list));
    } catch (e) {
        yield put({type: CommentActions.UpdateCommentAction.Failure});
        toastr.error('Błąd aktualizowania komentarza',
            'Wystąpił niespodziewany błąd podczas próby aktualizacji komentarza');

    }
}
function updateCommentRequest(comment) {
    return axios
        .put(`${commentUrl}/${comment.id}`, comment)
        .then(response => response.data)
        .catch(err => {
            throw err;
        });
};

export function* watchGetComment() {
    yield takeEvery(CommentActions.GetCommentAction.Request, getComment);
}

function* getComment(action) {
    try {
        let comment = yield call(getCommentRequest, action.payload);

        yield put({
            type: CommentActions.GetCommentAction.Success,
            payload: comment
        })
    } catch (err) {
        yield put({
            type: CommentActions.GetCommentAction.Failure,
        });
        toastr.error('Błąd pobierania komentarza', 'Wystąpił niespodziewany błąd podczas pobierania komentarza');
    }
}

function getCommentRequest(id) {
    return axios
        .get(`${commentUrl}/${id}`)
        .then(response => response.data)
        .catch(err => {
            throw err;
        });
}

export function* watchUnloadComment() {
    yield takeEvery(CommentActions.UnloadCommentAction.Request, unloadComment);
}

function* unloadComment() {
    yield put({
        type: CommentActions.UnloadCommentAction.Success
    });
}